import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BehaviorSubject } from "rxjs";
import * as _ from 'underscore';
import * as moment from "moment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ReportService {
    constructor(http) {
        this.http = http;
        this.participantsObs = new BehaviorSubject([]);
        this.participants$ = this.participantsObs.asObservable();
    }
    parseFilters(filters) {
        return this.parseFiltersLogic(filters, false);
    }
    parseFiltersWithArrayExc(filters) {
        return this.parseFiltersLogic(filters, true);
    }
    parseFiltersLogic(filters, withArr = false) {
        let str = "";
        // tslint:disable-next-line:forin
        for (const key in filters) {
            if (filters[key] !== null &&
                filters[key] !== undefined &&
                filters[key] !== "") {
                if (_.isDate(filters[key])) {
                    console.log(moment(filters[key]).format("YYYY-MM-DD"));
                    str += `${key}=${moment(filters[key]).format("YYYY-MM-DD")}&`;
                }
                else if (_.isString(filters[key]) || _.isNumber(filters[key])) {
                    str += `${key}=${filters[key]}&`;
                }
                else if (_.isArray(filters[key])) {
                    filters[key].forEach((element, index) => {
                        if (withArr) {
                            str += this._fromArrToSingle(key, element);
                        }
                        else {
                            str += this._fromArrToStringArr(key, index, element);
                        }
                    });
                }
                else {
                    console.log("dorzucić obsługę parsowania - ", typeof filters[key]);
                }
            }
        }
        return str;
    }
    _fromArrToStringArr(key, index, element) {
        return `${key}[${index}]=${element}&`;
    }
    _fromArrToSingle(key, element) {
        return `${key}=${element}&`;
    }
    getTrainingFrequency(filters) {
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFilters(filters);
        }
        return this.http.get(`${environment.api}/report/training-frequency?${urlParams}`);
    }
    getTrainingFrequencyExport(format, filters) {
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFilters(filters);
        }
        // tslint:disable-next-line:max-line-length
        return this.http.get(`${environment.api}/report/training-frequency/export/${format}?filename=training-frequency&${urlParams}`, { responseType: "blob" });
    }
    getClientFrequency(filters) {
        console.log(filters);
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFilters(filters);
        }
        return this.http.get(`${environment.api}/report/client-frequency?${urlParams}`);
    }
    getClientFrequencyExport(format, filters) {
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFiltersWithArrayExc(filters);
        }
        // tslint:disable-next-line:max-line-length
        return this.http.get(`${environment.api}/report/client-frequency/export/${format}?filename=client-frequency&${urlParams}`, { responseType: "blob" });
    }
    getHistorySalonTraining(external_id) {
        return this.http.get(`${environment.api}/client/${external_id}/report`);
    }
    getClientRecent(filters) {
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFilters(filters);
        }
        return this.http.get(`${environment.api}/report/client-recent?${urlParams}`);
    }
    getClientRecentExport(format, filters) {
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFilters(filters);
        }
        // tslint:disable-next-line:max-line-length
        return this.http.get(`${environment.api}/report/client-recent/export/${format}?filename=client-recent&${urlParams}`, { responseType: "blob" });
    }
    // getLoginUsers(filters?) {
    //   let urlParams = '';
    //   if (filters) {
    //     urlParams = this.parseFilters(filters);
    //   }
    //   return this.http.get(`${environment.api}/report/user-log?${urlParams}`);
    // }
    getLoginUsers(filters) {
        console.log(filters);
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFilters(filters);
            console.log(urlParams);
        }
        return this.http.get(`${environment.api}/report/user-log?${urlParams}`);
        // tslint:disable-next-line:max-line-length
        // return this.http.get(`${environment.api}/report/user-log?perPage=${perPage}&page=${page + 1}&direction=${direction}&sort=${sort}${ search ? ('&search=' + search) : '' }${ id ? ('&client_id=' + id) : '' }`);
    }
    getLoginUsersExport(format, filters) {
        let urlParams = "";
        if (filters) {
            urlParams = this.parseFilters(filters);
        }
        // tslint:disable-next-line:max-line-length
        return this.http.get(`${environment.api}/report/user-log/export/${format}?filename=user-log&${urlParams}`, { responseType: "blob" });
    }
}
ReportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportService_Factory() { return new ReportService(i0.ɵɵinject(i1.HttpClient)); }, token: ReportService, providedIn: "root" });
